import { render } from "./AdminRaterangeCreate.vue?vue&type=template&id=360dbc38&scoped=true&ts=true&lang=true"
import script from "./AdminRaterangeCreate.vue?vue&type=script&lang=ts"
export * from "./AdminRaterangeCreate.vue?vue&type=script&lang=ts"

import "./AdminRaterangeCreate.vue?vue&type=style&index=0&id=360dbc38&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360dbc38"]])

export default __exports__